import { ArrowLeft } from "lucide-react";
import { Link } from "../app/router";
import { PageMeta } from "../components/PageMeta";

export function NotFoundPage() {
  return (
    <section className="not-found">
      <PageMeta title="Không tìm thấy trang | Rêu Nắng" description="Trang này không có trong demo Rêu Nắng." />
      <span>404</span>
      <h1>Trang này chưa mọc.</h1>
      <p>Liên kết có thể đã đổi, nhưng Xưởng ban công vẫn đang mở.</p>
      <Link className="button button-primary" to="/"><ArrowLeft aria-hidden="true" /> Về trang chủ</Link>
    </section>
  );
}
